import { createRouteRef, createPlugin, createApiFactory, createComponentExtension } from '@backstage/core-plugin-api';
import { awsLambdaApiRef } from './api/AWSLambdaApi.esm.js';
import { AwsLambdaClient } from './api/AWSLambdaClient.esm.js';

const entityContentRouteRef = createRouteRef({
  id: "AWS Lambda Entity Content"
});
const awsLambdaPlugin = createPlugin({
  id: "aws-lambda",
  apis: [createApiFactory(awsLambdaApiRef, new AwsLambdaClient())],
  routes: {
    entityContent: entityContentRouteRef
  }
});
const EntityAWSLambdaOverviewCard = awsLambdaPlugin.provide(
  createComponentExtension({
    name: "EntityAWSLambdaOverviewCard",
    component: {
      lazy: () => import('./components/AWSLambdaOverview/AWSLambdaOverview.esm.js').then(
        (m) => m.AWSLambdaOverviewWidget
      )
    }
  })
);

export { EntityAWSLambdaOverviewCard, awsLambdaPlugin, entityContentRouteRef };
//# sourceMappingURL=plugin.esm.js.map
